const Theme = {
  KEY: "theme",
  DARAZ: "daraz",
  NTB: "ntb",
};
export default Theme;
